import adminApi from "services/admin-api";

export const workspaceAthleteService = {
  athletes: {
    get: adminApi.athletes.get,
    getAchievements: adminApi.athletes.getAchievements,
    getCalendarEvents: adminApi.athletes.getCalendarEvents,
    getCareers: adminApi.athletes.getCareers,
    getPositionsPlayed: adminApi.athletes.getPositionsPlayed,
    getSeasonStats: adminApi.athletes.getSeasonStats,
    list: adminApi.athletes.list,
    update: adminApi.athletes.update,
  },
  events: {
    create: adminApi.events.create,
    list: adminApi.events.list,
    remove: adminApi.events.remove,
    update: adminApi.events.update,
  },
  playerClasses: {
    create: adminApi.playerClasses.create,
    list: adminApi.playerClasses.list,
    remove: adminApi.playerClasses.remove,
    update: adminApi.playerClasses.update,
  },
  playerPerformanceRecords: {
    create: adminApi.playerPerformanceRecords.create,
    list: adminApi.playerPerformanceRecords.list,
    remove: adminApi.playerPerformanceRecords.remove,
    update: adminApi.playerPerformanceRecords.update,
  },
};
